import { useMemo } from 'react'

import { dayjs } from '../lib/dayjs.js'

export const useBrowserTimeZone = (): string => {
  return useMemo(() => dayjs.tz.guess(), [])
}
